<template>
  <div class="layout w-screen h-screen flex">
    <!-- 菜单 -->
    <div class="menu h-full" :style="{background:menuTheme.backgroundColor, width: isCollapse ? '0px': ''}">
      <div v-show="!isCollapse" class="flex logo-box" :style="{'max-width': isCollapse?'80px':'200px', 'align-items': 'center', 'padding': '0 20px', 'margin': '10px 0'}">
        <img style="width: 40px;" class="logo-img" src="../assets/logo2.png" alt="">
        <span style="font-size: 18px; margin-left: 10px; color: #fff;">iPay</span>
        <!-- <div v-if="!isCollapse" class="logo-name">熊猫币</div> -->
      </div>
      <el-scrollbar class="menu-scrollbar" style="height:calc(100% - 60px)">
        <el-menu
          :background-color="menuTheme.backgroundColor"
          :text-color="menuTheme.textColor"
          :active-text-color="menuTheme.activeTextColor"
          router :default-active="activeMenu" unique-opened class="el-menu-box" :collapse="isCollapse">
          <subItem
            v-for="item in menuPermission"
            :key="item.id"
            :item="item"
          />
        </el-menu>
      </el-scrollbar>
    </div>

    <div class="h-full flex-1 right-box" >
      <!-- 顶部 -->
      <div class="top-box flex justify-between items-center" :style="{position: 'relative', marginBottom: selectTab.length < 1 ? '0px' : '30px'}">
        <div class="flex items-center">
          <div @click="toggleIsCollapse" class="left-box cursor-pointer">
            <i v-show="isCollapse" class="el-icon-s-unfold"></i>
            <i v-show="!isCollapse" class="el-icon-s-fold"></i>
          </div>
          <el-page-header @back="goBack" :content="title" style="margin-left:40px; white-space:nowrap;"></el-page-header>
        </div>

        <div class="t-right-box flex items-center" >
          <!-- <div class="time">
            {{time}}
          </div> -->
          <el-carousel :interval="10000" indicator-position="none" style="width:250px" height="70px" direction="vertical">
            <el-carousel-item style="display: flex;color:#409EFF;" class="items-center" v-for="item in weather" :key="item.date">
              <h3 class="medium">{{item.date}}：{{ item.type }}&nbsp;&nbsp;{{ item.low.slice(3) }} ~ {{ item.high.slice(3) }} </h3>
            </el-carousel-item>
          </el-carousel>

          <el-button @click="setTheme"  type="success" icon="el-icon-s-open" circle></el-button>

          <el-dropdown>
            <div class="flex items-center user">
              <div class="rolename"><span style="color: #f56c6c;">{{ userInfo.username }}</span> <span style="font-size: 8px;">({{userRole}})</span></div>
              <img class="avatar rounded-full" :src="loginImg" alt="">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openPasswordDialog">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="logout">登出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="Breadcrumbs" v-if="!selectTab.length < 1">

          <el-tabs v-model="$selectBeard[0]" type="border-card" closable @tab-click="clickBread" @tab-remove="removeTab" style="height: 35px;">
            <el-tab-pane
              v-for="(item, index) in selectTab"
              :key="item.id"
              :label="item.title"
              :name="item.component"
              style="background-color: #fff;"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- 主区 -->
      <div class="bottom-box" :style="{marginTop: selectTab.length < 1 ? '0px' : '50px'}">
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>

    <el-dialog
      destroy-on-close
      title="修改密码"
      :visible.sync="passwordDialog"
      width="30%"
    >
      <el-form :model="passwordDialogForm" :rules="passwordDialogFormRules" ref="passwordDialogForm" label-width="100px">
        <el-form-item label="老密码" prop="old_password">
          <el-input v-model="passwordDialogForm.old_password" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input v-model="passwordDialogForm.new_password" show-password clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('passwordDialogForm')">确定</el-button>
          <el-button @click="passwordDialog = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import { passwordEdit } from '@/api/user'
import subItem from './subItem.vue'
import loginImg from '../assets/logo2.png'
import axios from 'axios'
export default {
  components: {
    subItem
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path === '/login') {
        
      }
    })
  },
  created () {
    
    this.time = this.vtimeFormat(Date.now())
    const t = setInterval(() => {
      this.time = this.vtimeFormat(Date.now())
    }, 1000)
    this.$once('hook:beforeDestroy', () => {
      clearInterval(t)
    })
  },
  data () {
    return {
      editableTabsValue: this.$selectBeard[0],
      selectTab: this.$beard,
      editableTabs: [{
        title: 'Tab 1',
        name: '1',
        content: 'Tab 1 content'
      }, {
        title: 'Tab 2',
        name: '2',
        content: 'Tab 2 content'
      }],
      tabIndex: 2,
      weather: [],
      time: '',
      loginImg: loginImg,
      passwordDialogForm: {
        old_password: '',
        new_password: ''
      },
      passwordDialogFormRules: {
        old_password: [
          { required: true, message: '请输入老密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不少于6个字符', trigger: 'blur' }
        ]
      },
      passwordDialog: false,
      logo: 'https://www.keaidian.com/uploads/allimg/190424/24110307_8.jpg'
    }
  },
  computed: {
    menuTheme () {
      const menuTheme = [
        {
          backgroundColor: '#545c64',
          textColor: '#ddd',
          activeTextColor: '#45aaf2'
        },
        {
          backgroundColor: '#40407a',
          textColor: '#ddd',
          activeTextColor: '#ff9f1a'
        }
      ]
      if (this.theme) {
        return menuTheme[1]
      } else {
        return menuTheme[0]
      }
    },
    theme () {
      return this.$store.getters.theme
    },
    isCollapse () {
      return this.$store.getters.isCollapse
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    userRole () {
      return this.$store.getters.menu.res.name
    },
    activeMenu () {
      return this.$route.path
    },
    menuPermission () {
      return this.$store.getters.menuPermission
    },
    title () {
      return this.$store.getters.titlelist[this.activeMenu]
    }
  },
  watch: {
    theme: {
      handler (newValue) {
        const body = document.body
        if (newValue) {
          body.classList.add('theme')
        } else {
          body.classList.remove('theme')
        }
      },
      immediate: true
    }
  },
  methods: {
    removeTab (targetName) {
      
      const a = []
      this.$beard.forEach(res => {
        if (res.component !== targetName) {
          a.push(res)
        }
      })
      Vue.set(this, 'selectTab', a)
      Vue.prototype.$beard = a
      Vue.prototype.$selectBeard[0] = this.$beard[this.$beard.length - 1].component
      
      if (this.$selectBeard[0] === this.$route.path) {
        return 0
      }
      this.$router.push({ path: this.$selectBeard[0] })
    },
    // 切换了面包屑
    clickBread (e) {
      if (this.$selectBeard[0] === this.$route.path) {
        return 0
      }
      // this.$set(this.$selectBeard, 'path', e.name)
      this.$selectBeard.splice(0, 1, e.name)
      this.$router.push({ path: e.name })
    },
    setTheme () {
      const loading = this.$loading({
        background: 'rgba(0, 0, 0, 0.8)'
      })
      setTimeout(() => {
        this.$store.commit('set_theme', !this.theme)
        loading.close()
      }, 800)
    },
    // greeting () {
    //   this.$axios({
    //     url: '/admin/homePage/greetings'
    //   }).then(res => {
    //     this.$notify({
    //       title: '欢迎使用',
    //       message: res,
    //       type: 'success',
    //       offset: 60,
    //       duration: 3000
    //     })
    //   })
    // },
    goBack () {
      this.$router.back()
    },
    openPasswordDialog () {
      this.passwordDialogForm = {
        old_password: '',
        new_password: ''
      }
      this.passwordDialog = true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          passwordEdit({
            ...this.passwordDialogForm
          }).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.passwordDialog = false
          })
        } else {
          return false
        }
      })
    },
    toggleIsCollapse () {
      this.$store.commit('set_isCollapse', !this.isCollapse)
    },
    logout () {
      this.$store.dispatch('logout').then(res => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.rolename {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Breadcrumbs {
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  width: 100%;
  height: 30px;
  background-color: saddlebrown;
}
.layout{
  .menu{
    .menu-scrollbar{
      ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
    ::v-deep{
      .el-submenu__title i{
        color: inherit;
      }
      .el-menu-item i{
        color: inherit;
      }
    }
    border-right:1px solid #eee;
    .logo-box{
      transition: max-width .5s;
      height: auto;
      .logo-img{
        // width: 30px;
        // height: 30px;

        width: 100%;
      }
      .logo-name{
        margin: 0 5px;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .el-menu-box{
      border: none;
    }
    .el-menu-box:not(.el-menu--collapse) {
      width: 200px;
    }
    .el-menu-box.el-menu--collapse ::v-deep{
      .el-submenu__title > span {
        height: 0;
        width: 0;
        overflow: hidden;
        visibility: hidden;
        display: inline-block;
        &+.el-submenu__icon-arrow.el-icon-arrow-right{
          height: 0;
          width: 0;
          overflow: hidden;
          visibility: hidden;
          display: inline-block;
        }
    }
    }

  }
  .right-box{
    overflow: hidden;
    .top-box{
      border-bottom:1px solid #eee;
      height: 70px;
      padding: 0 20px;
      .left-box{
        font-size: 20px;
      }
      .t-right-box{
        .time{
          color: #666;
          margin-right: 40px;
          white-space:nowrap;
          // font-weight: bold;
          // font-size: 18px;
        }
        .user{
          > *{
            margin-left: 10px;
          }
          .avatar{
            width: 40px;
            height: 40px;
          }
        }

      }
    }
    .bottom-box{
      height: calc(100% - 70px);
      padding: 20px;
      // overflow-y: auto;
      // overflow-x: hidden;
      &>div{
        height:100%;
        // overflow: hidden;
        display: flex;
        flex-direction: column;
      }
      
      ::v-deep .el-table{
        overflow: auto !important;
      }
    }
    .fade-transform-leave-active,
      .fade-transform-enter-active {
        transition: all .5s;
      }

      .fade-transform-enter {
        opacity: 0;
        transform: translateX(-50px);
      }

      .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(50px);
      }
  }
}

</style>
